import { render, staticRenderFns } from "./DotText.vue?vue&type=template&id=4fc914c6&scoped=true"
import script from "./DotText.vue?vue&type=script&lang=js"
export * from "./DotText.vue?vue&type=script&lang=js"
import style0 from "./DotText.vue?vue&type=style&index=0&id=4fc914c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc914c6",
  null
  
)

export default component.exports